<template>
  <div>
    <div class="nav-top">
      <div class="nav-left" @click="back()">
        <img src="../../assets/img/返回箭头.png" class="nav-img" />
        <span class="nav-lable"></span>
      </div>
      <div class="nav-middle">陪玩</div>
      <div class="nav-right">
        <img class="none" />
      </div>
    </div>

    <div class="top-img">
      <img src="../../assets/img/top.jpg"/>
    </div>

    <div class="tit ub ub-pc ub-ac2">
      <div class="d1 ub ub-pc ub-ac">
        <span>智能排序</span>
      </div>

      <div class="d2 ub ub-pc ub-ac">
        <span>性别：</span>
        <select>
          <option value ="全部">全部</option>
          <option value ="男生">男生</option>
          <option value="女生">女生</option>
        </select>
      </div>

      <div class="d3 ub ub-pc ub-ac">
        <span>等级：</span>
        <select>
          <option value ="全部">全部</option>
          <option value ="普通">普通</option>
          <option value="金牌">金牌</option>
           <option value ="镇店">镇店</option>
        </select>
      </div>
    </div>
  <div v-for="(item, index) in ary" :key="index" @click="goto_play_dtl(item.uid)">
    <div class="infoma ub">
      <div class="photo-black">
        <img :src="item.photo" class="photo" />
        <span class="photo-tag ub ub-pc ub-ac">{{item.play_level}}</span>
      </div>
      <div class="ub ub-ver ub-f1">
        <div class="ub">
          <div class="ub ub-pc">
            <span class="nick2">{{item.nick}}</span>
            <img v-if="item.sex=='女生'" src="../../assets/img/女.png" class="sex-img" />
            <img v-if="item.sex=='男生'" src="../../assets/img/男.png" class="sex-img" />
          </div>
          <div class="ub ub-f1 ub-ae">
            <div class="tip ub ub-pc" v-for="(i, index) in item.serve" :key="index">
              <div class="d1"></div>
              <span class="sp2">{{i}}</span>
            </div>
          </div>
        </div>

        <div>
          <span class="tag"  v-for="(t, index) in item.tags" :key="index">{{t}}</span>
        </div>
        <div>
          <div class="voice ub ub-pc">
           <img src="../../assets/img/声音.png" class="voice-img" />
           <span>播放</span>
         </div>
        </div>
      </div>
    </div>

    <div class="ub" style="padding:0 .8em">
            <div class="menu-line"></div>
    </div>
</div>

  </div>
</template>

<script>
import * as tool from "../../api/common";
import { mapMutations, mapActions } from "vuex";

export default {
  data() {
    return {
      index: 0,
      size: 20,
       ary:[
        {
          id: "123345346575678",
          photo: "http://xhcapp_i.zhuochuangzb.com/photo/photo_boy/1407.jpg",
          play_level:"镇店",
          nick: "鸣人",
          sex: "女生",
          serve: ["在线","语音","陪玩"],
          tags:["甜甜咸咸","乖巧","爱狗狗","哄睡","小话唠",],
          voice:""
        },
        {
          id: "123345346575678",
          photo: "http://xhcapp_i.zhuochuangzb.com/photo/photo_boy/1407.jpg",
          play_level:"镇店",
          nick: "鸣人",
          sex: "女生",
          serve: ["在线","语音","陪玩"],
          tags:["甜甜咸咸","乖巧","爱狗狗","哄睡","小话唠",],
          voice:""
        },
        {
          id: "123345346575678",
          photo: "http://xhcapp_i.zhuochuangzb.com/photo/photo_boy/1407.jpg",
          play_level:"镇店",
          nick: "鸣人",
          sex: "女生",
          serve: ["在线","语音","陪玩"],
           tags:["甜甜咸咸","乖巧","爱狗狗","哄睡","小话唠",],
          voice:""
        },
      ],
    };
  },
  mounted() {
    this.init_page();
      },
  methods: {
    ...mapMutations(["get", "post"]), //引入方法
     back() {
      this.$router.go(-1); //返回上一层
    },
    goto_play_dtl(uid_to){
      this.$router.push({ name: "play_dtl", "params": { "uid_to":uid_to} });
    },
    init_page(){
      var self = this;
      self.get({
        url:
          "/App/Get_Play_List_Data/?index=" +
          this.index +
          "&size=" +
          this.size,
        success: function (data) {
          console.log(JSON.stringify(data));
          self.$loading.close();

          if (data.length <= 0 && self.index > 0) {
            self.$toast.bottom("没有更多了~");
          }
          self.index++;

          for (var i = 0; i < data.length; i++) {
            data[i].tags = data[i].tags.split(',');
          }
          self.ary = data;
        
        },
      });
    }
  },
};
</script>

<style scoped>
.top-img{
  padding: .8em;
  background-color: #FFF;
}
.top-img img{
  width: 100%;
  border-radius: .5em;
}
.tit{
  background-color: #FFF;
}
.tit div {
  height: 3.3em;
  font-weight: bold;
  color: #333;
  font-size: 0.95em;
  width: 33.3%;
}
.d1 {
  border-bottom: 1px solid #f4f5f6;
}
.d2 {
  border-left: 1px solid #f4f5f6;
  border-right: 1px solid #f4f5f6;
  border-bottom: 1px solid #f4f5f6;
}
.d3 {
  border-bottom: 1px solid #f4f5f6;
}
.infoma {
  padding: 1.3em .8em;
  background-color: #FFF;
}
.infoma:hover{
  background-color: #f2f3f5;
}

.photo-black{
  width: 5em;
  height: 5em;
  margin-right: .5em;
  position: relative;
}
.photo-tag{
  position: absolute;
  background-color: #f3b4cf;
  font-size: .8em;
  border-radius: 1em;
  color: #fff;
  padding: .1em .2em;
  width: 3em;
  bottom: .5em;
  right: .2em;
}
.photo {
  width: 5em;
  height: 5em;
  border-radius: 50%;
  
}
.nick2 {
  font-weight: bold;
  font-size: 0.85em;
   margin-left: .3em;
}
.sex-img {
  width: 1.2em;
}
.tip {
  margin-right: 0.5em;
}
.tip .d1 {
  width: 0.5em;
  height: 0.5em;
  background-color: #5ea3ef;
  border-radius: 50%;
  margin-right: 0.2em;
}
.tip .sp2{
  font-size: 0.85em;
}
.tag{
  display: inline-block;
  padding: .2em .5em;
  border:1px solid #5ea3ef;
  border-radius: 1em;
  font-size: .8em;
  color: #5ea3ef;
  margin: .3em .3em;
}
.voice{
  background-color: #5ea3ef;
  margin-left:.3em;
  font-size: .8em;
  width: 6em;
  color: #fff;
  padding: .5em .5em;
  border-radius: 2em;
  margin-top: .5em;
}
.voice-img{
width: 1.5em;
height: 1.5em;
margin-left: .5em;
}
select{
  background: transparent;
  border: none;
  font-size: 1em;
  color: #e92162;
}
</style>